import { render } from "./Section8.vue?vue&type=template&id=24d7d278"
import script from "./Section8.vue?vue&type=script&lang=js"
export * from "./Section8.vue?vue&type=script&lang=js"

import "./Section8.vue?vue&type=style&index=0&id=24d7d278&lang=scss"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__